import { createFilterSlice } from './filterSlice';

const STORAGE_KEY = 'clientContactsFilters';
const defaultFilters = {
	ownerIds: [],
	brokerGroupId: null,
	isPrimary: 'all',
};

export const clientContactsPrefsSlice = createFilterSlice({
	sliceName: 'clientContactsPrefs',
	storageKey: STORAGE_KEY,
	defaultFilters,
});

export const { setOwnerIds, setBrokerGroupId, setIsPrimary, resetFilters } =
	clientContactsPrefsSlice.actions;

export default clientContactsPrefsSlice.reducer;
